import { useQuery } from '@tanstack/react-query';
import { api } from '../services/api';
import { useAuthStore } from '../store/authStore';

/** D-326: the NUMBER OF CHATS with unread messages (like WhatsApp). Shared by the menu, the tab and the floating bubble. */
export function useChatUnreadChats(): number {
  const user = useAuthStore((s) => s.user);
  const staff = user?.role === 'admin' || user?.role === 'agent';
  const { data } = useQuery({
    queryKey: ['chat-unread-count'],
    queryFn: () => api.getChatUnreadCount(),
    enabled: staff,
    refetchInterval: 30_000,
    staleTime: 10_000,
  });
  return staff ? (data?.data?.chats ?? 0) : 0;
}
